// extracted by mini-css-extract-plugin
export default {"container":"JSrS5j","lg":"iT8b39","content":"AnUn_n","image":"axHrxY","cta":"KQwNMl"};